/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var YandexInternationalIcon = createIcon({
  name: 'YandexInternationalIcon',
  height: 512,
  width: 320,
  svgPath: 'M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default YandexInternationalIcon;